module.exports = __webpack_public_path__ + "HelveticaOblique.12cd25bb702708ecea36.woff2";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/Helvetica/HelveticaOblique.woff2
// module id = ../../../../../src/app/@theme/fontes/Helvetica/HelveticaOblique.woff2
// module chunks = styles